import React from "react";
import { Button as ReactstrapButton } from "reactstrap";

// App
import { ButtonProps } from "../../../../types";
import useButtonStyles from "./styles";

const Button: React.FC<ButtonProps> = (props) => {
    const { className, style, color = "", disabled, onClick, children } = props;
    const buttonStyles = useButtonStyles();
    return (
        <ReactstrapButton
            className={className}
            style={{ ...buttonStyles.root, ...buttonStyles.contained, ...style }}
            color={color}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </ReactstrapButton>
    );
};

export default Button;
